import { Injectable, Inject } from '@angular/core';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { ApiCommonService } from 'cbc-shared-lib';
import { map, timeout, catchError } from 'rxjs/operators';
import { Sgkz030aRequest, Sgkz030aResponse, SGKZ030AService } from 'sg-api';
import { FEATURES_LIB_CONFIG } from '../../../../../config/features-lib-config.token';
import { FeaturesLibConfig } from '../../../../../config/features-lib-config';

/**
 * 履歴情報を管理するサービス。
 * @export
 * @class UsedSgkz030aService
 */
@Injectable({
  providedIn: 'root'
})
export class UsedSgkz030aService {

  /** 更新履歴情報取得結果 */
  private _searchResult$: BehaviorSubject<Sgkz030aResponse> = new BehaviorSubject<Sgkz030aResponse>({});

  /**
   * 更新履歴情報のobservable提供
   *
   * @readonly
   * @memberof UsedSgkz030aService
   */
  get getSgkz030aResponse(): Observable<Sgkz030aResponse> {
    return this._searchResult$.asObservable();
  }

  /**
   * コンストラクタ
   * 
   * @param {SZMC601AService} sGKZ030AService
   * @param {ApiCommonService} apiCommonService
   * @memberof UsedSgkz030aService
   */
  constructor(private sGKZ030AService: SGKZ030AService, private apiCommonService: ApiCommonService, @Inject(FEATURES_LIB_CONFIG) private featuresLibConfig: FeaturesLibConfig) { }

  /**
   * API呼び出し
   *
   * @memberof UsedSgkz030aService
   */
  search(historyManagementGroup: string, historyManagementKey: string) {
    // 初期化
    this._searchResult$.next({});

    let request: Sgkz030aRequest = {
      requestCommon: {},
      rrkMngGrp: historyManagementGroup,
      rrkMngKey: historyManagementKey
    };

    this.sGKZ030AService.kz10RSGKZ030APost(this.apiCommonService.setRequestCommon(request), 'response').pipe(
      map((response) => {
        // エラーが設定されていないかチェックする
        this.apiCommonService.checkError(response);

        this._searchResult$.next(response.body);
      }),
      timeout(Number(this.featuresLibConfig.httpTimeout)),
      catchError((err) => {
        this.apiCommonService.dispErrorMessage(err, 'sys', 'SGKZ030A');
        return throwError(err.message);
      }))
      .subscribe();
  }

}
